// import React, { useEffect, useState } from "react";
// import { Row, Col } from "react-bootstrap";
// import "../../../assets/css/modulemanagement.scss";
// import Select from 'react-select';
// import { useDispatch, useSelector } from "react-redux";
// import { loadCompanyDropdownData, loadModuleSubModules } from "../../../redux/action";

// const modulesData1 = [
//     {
//         category: "Leave Management",
//         status: true,
//         items: ["Dashboards", "Leave Management Module"],
//     },
//     {
//         category: "Complaints and Escalation",
//         status: true,
//         items: ["Dashboards", "Complains and Escalation Module"],
//     },
//     {
//         category: "AMC or SLA Module",
//         status: false,
//         items: ["Dashboards", "AMC or SLA Module"],
//     },
//     {
//         category: "Ticketing Interface",
//         status: true,
//         items: ["Dashboards", "Ticketing Module"],
//     },
//     {
//         category: "Planning & Forecasting",
//         status: true,
//         items: ["Dashboards", "Planning & Forecasting Module"],
//     },
//     {
//         category: "Inventory Management",
//         status: false,
//         items: ["Dashboards", "Inventory Optimization Module", "Criticality Analytics Module"],
//     },
// ];

// const modulesData2 = [
//     {
//         category: "Warehousing",
//         status: true,
//         items: ["Dashboards", "Basic Warehouse Transactions", "Repair & Return", "Preservation Module", "Quality Module", "Asset Module", "Laptop Tracking", "Advanced Analytics (AI/ML)", "Order Management"],
//     },
//     {
//         category: "Category Management",
//         status: true,
//         items: ["Dashboards"],
//     },
//     {
//         category: "Investment Recovery",
//         status: false,
//         items: ["Dashboards", "Investment Recovery Module"],
//     },
//     {
//         category: "Logistics & Delivery",
//         status: true,
//         items: ["Dashboards", "Logistics & Delivery Module", "ASN Module"],
//     },
// ];

// const MenubarTable = () => {
//     const dispatch = useDispatch();
//     const { getModuleSubModules } = useSelector((state) => state.data);
//     const { getCompanyDropdown } = useSelector((state) => state.data);
//     const [modules1, setModules1] = useState(modulesData1);
//     const [modules2, setModules2] = useState(modulesData2);

//     const toggleModuleStatus = (index, column) => {
//         const modules = column === 1 ? [...modules1] : [...modules2];
//         modules[index].status = !modules[index].status;
//         column === 1 ? setModules1(modules) : setModules2(modules);
//     };

//     useEffect(() => {
//         dispatch(loadModuleSubModules());
//         dispatch(loadCompanyDropdownData());
//     }, [])

//     return (
//         <div className="module-management-container">
//             <Row className="justify-content-between">
//                 <Col md={4}>
//                     <h6>Menu Bar Enable / Disable</h6>
//                 </Col>
//                 <Col md={3}>
//                     <Select
//                         className="react-select-container"
//                         classNamePrefix="react-select"
//                         value={getCompanyDropdown}
//                         //   onChange={handleChange}
//                         // options={contactOptions}
//                         placeholder="Select Client"
//                     />
//                 </Col>
//             </Row>
//             <Row>
//                 <Col md={6} className="modules-grid1">
//                     {modules1.map((module, index) => (
//                         <div className="module-container p-3 pb-0" key={index}>
//                             <div className="modulename-header-div">
//                                 <p>{module.category}</p>
//                                 <div className="custom-toggle-switch">
//                                     <input
//                                         type="checkbox"
//                                         className="custom-toggle-input"
//                                         id={`custom-switch-1-${index}`}
//                                         checked={module.status}
//                                         onChange={() => toggleModuleStatus(index, 1)}
//                                     />
//                                     <label
//                                         className={`custom-toggle-label ${module.status ? "enabled" : "disabled"}`}
//                                         htmlFor={`custom-switch-1-${index}`}
//                                     >
//                                         {module.status ? "Enable" : "Disable"}
//                                     </label>
//                                 </div>
//                             </div>
//                             <div className="module-names-container">
//                                 {module.items.map((item, idx) => (
//                                     <div className="form-check" key={idx}>
//                                         <input
//                                             className="form-check-input"
//                                             type="checkbox"
//                                             id={`item-1-${index}-${idx}`}
//                                             checked={module.status}
//                                             readOnly
//                                         />
//                                         <label className="form-check-label" htmlFor={`item-1-${index}-${idx}`}>
//                                             {item}
//                                         </label>
//                                     </div>
//                                 ))}
//                             </div>
//                             <hr />
//                         </div>
//                     ))}
//                 </Col>
//                 <Col md={6} className="modules-grid2">
//                     {modules2.map((module, index) => (
//                         <div className="module-container p-3 pb-0" key={index}>
//                             <div className="modulename-header-div">
//                                 <p>{module.category}</p>
//                                 <div className="custom-toggle-switch">
//                                     <input
//                                         type="checkbox"
//                                         className="custom-toggle-input"
//                                         id={`custom-switch-2-${index}`}
//                                         checked={module.status}
//                                         onChange={() => toggleModuleStatus(index, 2)}
//                                     />
//                                     <label
//                                         className={`custom-toggle-label ${module.status ? "enabled" : "disabled"}`}
//                                         htmlFor={`custom-switch-2-${index}`}
//                                     >
//                                         {module.status ? "Enable" : "Disable"}
//                                     </label>
//                                 </div>
//                             </div>
//                             <div className="module-names-container">
//                                 {module.items.map((item, idx) => (
//                                     <div className="form-check" key={idx}>
//                                         <input
//                                             className="form-check-input"
//                                             type="checkbox"
//                                             id={`item-2-${index}-${idx}`}
//                                             checked={module.status}
//                                             readOnly
//                                         />
//                                         <label className="form-check-label" htmlFor={`item-2-${index}-${idx}`}>
//                                             {item}
//                                         </label>
//                                     </div>
//                                 ))}
//                             </div>
//                             <hr />
//                         </div>
//                     ))}
//                 </Col>
//             </Row>
//         </div>
//     );
// };

// export default MenubarTable;



// import React, { useState, useEffect } from "react";
// import { Row, Col } from "react-bootstrap";
// import Select from "react-select";
// import "../../../assets/css/modulemanagement.scss";
// import * as HeaderAuthentication from "../../HeaderAuthentication";
// import { useDispatch } from "react-redux";
// import { postModuleSubModuleDatas } from "../../../redux/action";
// import { ADDED_BY_ID } from "../../Constants";

// const MenubarTable = ({ getModuleSubModules, getCompanyDropdown }) => {
//     const dispatch = useDispatch();
//     const [modules, setModules] = useState([]);
//     const [selectedCompany, setSelectedCompany] = useState(null); // Store selected company

//     useEffect(() => {
//         if (Array.isArray(getModuleSubModules)) {
//             setModules(getModuleSubModules);
//         }
//     }, [getModuleSubModules]);

//     // Handle Company Selection
//     const handleCompanyChange = (selectedOption) => {
//         setSelectedCompany(selectedOption?.value || null);
//     };

//     // Function to send API request
//     const sendApiRequest = (moduleId, subModuleId = 0, isAssigned) => {
//         if (!selectedCompany) {
//             console.warn("No company selected, API request not sent.");
//             return;
//         }

//         const data = {
//             CompanyID: selectedCompany, // Use selected company ID
//             ModulesID: moduleId,
//             SubModulesID: subModuleId || 0, // Default to 0 if no submodule
//             IsAssigned: isAssigned,
//             AddedByID: ADDED_BY_ID,
//         };

//         let requestOption = {
//             method: "POST",
//             mode: "cors",
//             headers: HeaderAuthentication.postExcomatixAuth,
//             body: JSON.stringify(data),
//         };

//         dispatch(postModuleSubModuleDatas(requestOption));
//         console.log("API Sent:", data);
//     };

//     // Toggle Main Module Status
//     const toggleModuleStatus = (index) => {
//         setModules((prevModules) => {
//             const updatedModules = [...prevModules];
//             const isModuleEnabled = !updatedModules[index].IsAssined;

//             updatedModules[index] = {
//                 ...updatedModules[index],
//                 IsAssined: isModuleEnabled,
//                 SubModules: updatedModules[index].SubModules
//                     ? updatedModules[index].SubModules.map((sub) => ({
//                           ...sub,
//                           IsAssigned: isModuleEnabled,
//                       }))
//                     : [], // Ensure SubModules is at least an empty array
//             };

//             // Send API for the main module
//             sendApiRequest(updatedModules[index].ModuleID, 0, isModuleEnabled);

//             // Send API for all submodules if enabling
//             if (isModuleEnabled && updatedModules[index].SubModules?.length > 0) {
//                 updatedModules[index].SubModules.forEach((sub) =>
//                     sendApiRequest(updatedModules[index].ModuleID, sub.SubModulesID, true)
//                 );
//             }

//             return updatedModules;
//         });
//     };

//     // Toggle Individual Sub-Module Status
//     const toggleSubModuleStatus = (moduleIndex, subIndex) => {
//         setModules((prevModules) => {
//             const updatedModules = [...prevModules];

//             // Ensure submodules exist before modifying
//             if (!updatedModules[moduleIndex].SubModules) {
//                 updatedModules[moduleIndex].SubModules = [];
//             }

//             const updatedSubModules = [...updatedModules[moduleIndex].SubModules];

//             // Toggle the specific submodule
//             updatedSubModules[subIndex] = {
//                 ...updatedSubModules[subIndex],
//                 IsAssigned: !updatedSubModules[subIndex].IsAssigned,
//             };

//             // Check if at least one submodule is enabled
//             const anySubmoduleEnabled = updatedSubModules.some((sub) => sub.IsAssigned);

//             // Update the module state
//             updatedModules[moduleIndex] = {
//                 ...updatedModules[moduleIndex],
//                 IsAssined: anySubmoduleEnabled, // Enable module if any submodule is enabled
//                 SubModules: updatedSubModules,
//             };

//             // Send API for the submodule
//             sendApiRequest(
//                 updatedModules[moduleIndex].ModuleID,
//                 updatedSubModules[subIndex].SubModulesID,
//                 updatedSubModules[subIndex].IsAssigned
//             );

//             return updatedModules;
//         });
//     };

//     return (
//         <div className="module-management-container">
//             {/* Header Section */}
//             <Row className="justify-content-between">
//                 <Col md={4}>
//                     <h6>Menu Bar Enable / Disable</h6>
//                 </Col>
//                 <Col md={3}>
//                     <Select
//                         className="react-select-container"
//                         classNamePrefix="react-select"
//                         options={getCompanyDropdown}
//                         placeholder="Select Client"
//                         onChange={handleCompanyChange}
//                     />
//                 </Col>
//             </Row>

//             {/* Modules Section */}
//             <Row>
//                 <Col md={12} className="modules-grid">
//                     {modules.map((module, index) => (
//                         <div className="module-container p-3 pb-0" key={index}>
//                             <div className="modulename-header-div">
//                                 <p>{module.Module}</p>
//                                 <div className="custom-toggle-switch">
//                                     <input
//                                         type="checkbox"
//                                         className="custom-toggle-input"
//                                         id={`module-switch-${index}`}
//                                         checked={module.IsAssined}
//                                         onChange={() => toggleModuleStatus(index)}
//                                         disabled={!selectedCompany} // Disable if no company selected
//                                     />
//                                     <label
//                                         className={`custom-toggle-label ${module.IsAssined ? "enabled" : "disabled"}`}
//                                         htmlFor={`module-switch-${index}`}
//                                     >
//                                         {module.IsAssined ? "Enable" : "Disable"}
//                                     </label>
//                                 </div>
//                             </div>

//                             {/* Sub-Modules Section */}
//                             <div className="module-names-container">
//                                 {Array.isArray(module.SubModules) && module.SubModules.length > 0 ? (
//                                     module.SubModules.map((sub, subIndex) => (
//                                         <div className="form-check ms-3" key={subIndex}>
//                                             <input
//                                                 className="form-check-input"
//                                                 type="checkbox"
//                                                 id={`submodule-${index}-${subIndex}`}
//                                                 checked={sub.IsAssigned}
//                                                 onChange={() => toggleSubModuleStatus(index, subIndex)}
//                                                 disabled={!selectedCompany} // Disable if no company selected
//                                             />
//                                             <label className="form-check-label" htmlFor={`submodule-${index}-${subIndex}`}>
//                                                 {sub.SubModulesName}
//                                             </label>
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <p className="text-muted ms-3">No submodules available</p>
//                                 )}
//                             </div>

//                             <hr />
//                         </div>
//                     ))}
//                 </Col>
//             </Row>
//         </div>
//     );
// };

// export default MenubarTable;







import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import "../../../assets/css/modulemanagement.scss";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { loadCompanyDropdownData, loadModuleSubModules, loadRoleBasedModulePermissionsData, postModuleSubModuleDatas } from "../../../redux/action";
import { ADDED_BY_ID } from "../../../Constants";
import * as HeaderAuthentication from "../../HeaderAuthentication";

const MenubarTable = () => {
    const dispatch = useDispatch();
    const { getModuleSubModules, getCompanyDropdown, modulePermissions } = useSelector((state) => state.data);
    const [modules, setModules] = useState([]);
    // const [selectedCompany, setSelectedCompany] = useState(null);

    useEffect(() => {
        dispatch(loadModuleSubModules());
        dispatch(loadCompanyDropdownData());
    }, [dispatch]);

    useEffect(() => {
        if (getModuleSubModules?.length) {
            const formattedModules = getModuleSubModules.reduce((acc, module) => {
                const existingModule = acc.find(m => m.ModuleID === module.ModuleID);
                if (existingModule) {
                    existingModule.SubModules.push(...module.SubModules);
                } else {
                    acc.push({
                        ModuleID: module.ModuleID,
                        category: module.Module,
                        status: module.IsAssigned,
                        SubModules: module.SubModules || []
                    });
                }
                return acc;
            }, []);
            setModules(formattedModules);
        }
    }, [getModuleSubModules]);

    const getSideMenue = () => {
        dispatch(loadRoleBasedModulePermissionsData());
    }

    // ✅ API Call Function
    const sendApiRequest = (moduleId, subModuleId = 0, isAssigned) => {
        const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));

        // Fallback to signed-in user's CompanyID if no company is selected
        const companyID = signInDetails?.[0]?.CompanyID;

        if (!companyID) {
            console.warn("No company ID available, API request not sent.");
            return;
        }

        const data = {
            CompanyID: companyID, // ✅ Ensure a valid CompanyID is used
            ModulesID: moduleId,
            SubModulesID: subModuleId, // Default to 0 if no submodule
            IsAssigned: isAssigned,
            AddedByID: ADDED_BY_ID,
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        dispatch(postModuleSubModuleDatas(requestOption, getSideMenue));
        console.log("API Sent:", data);
    };

    // ✅ Toggle module status
    // const toggleModuleStatus = (index) => {
    //     const updatedModules = [...modules];
    //     updatedModules[index].status = !updatedModules[index].status;
    //     setModules(updatedModules);

    //     // API call when module toggles
    //     sendApiRequest(updatedModules[index].ModuleID, 0, updatedModules[index].status);
    // };

    const toggleModuleStatus = (index) => {
        const updatedModules = [...modules];
        const module = updatedModules[index];

        module.status = !module.status; // Toggle the main module

        // If enabling, check all submodules; if disabling, uncheck all submodules
        module.SubModules.forEach(submodule => {
            submodule.IsAssigned = module.status; // Set submodule status same as main module
            sendApiRequest(module.ModuleID, submodule.SubModulesID, module.status); // API call for each submodule
        });

        setModules(updatedModules);

        // API call for the main module toggle
        sendApiRequest(module.ModuleID, 0, module.status);
    };

    // ✅ Toggle submodule status
    const handleSubModuleToggle = (moduleIndex, submoduleIndex) => {
        const updatedModules = [...modules];
        const submodule = updatedModules[moduleIndex].SubModules[submoduleIndex];
        submodule.IsAssigned = !submodule.IsAssigned;
        setModules(updatedModules);

        // API call when submodule toggles
        sendApiRequest(updatedModules[moduleIndex].ModuleID, submodule.SubModulesID, submodule.IsAssigned);
    };

    // ✅ Handle company selection
    // const handleCompanyChange = (selectedOption) => {
    //     setSelectedCompany(selectedOption);
    //     dispatch(loadModuleSubModules(selectedOption?.value)); // Pass selected company ID
    // };

    return (
        <div className="module-management-container">
            <Row className="justify-content-between">
                <Col md={4}>
                    <h6>Menu Bar Enable / Disable</h6>
                </Col>

            </Row>
            <Row>
                {modules.map((module, index) => (
                    <Col md={6} key={index} className={index % 2 === 0 ? "modules-grid1" : "modules-grid2"}>
                        <div className="module-container p-3 pb-0">
                            <div className="modulename-header-div">
                                <p>{module.category}</p>
                                <div className="custom-toggle-switch">
                                    <input
                                        type="checkbox"
                                        className="custom-toggle-input"
                                        id={`custom-switch-${index}`}
                                        checked={module.status}
                                        onChange={() => toggleModuleStatus(index)}
                                    />
                                    <label
                                        className={`custom-toggle-label ${module.status ? "enabled" : "disabled"}`}
                                        htmlFor={`custom-switch-${index}`}
                                    >
                                        {module.status ? "Enable" : "Disable"}
                                    </label>
                                </div>
                            </div>
                            <div className="module-names-container">
                                {module.SubModules.length > 0 ? (
                                    module.SubModules.map((submodule, idx) => (
                                        <div className="form-check" key={idx}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`submodule-${index}-${idx}`}
                                                checked={submodule.IsAssigned}
                                                onChange={() => handleSubModuleToggle(index, idx)}
                                            />
                                            <label className="form-check-label" htmlFor={`submodule-${index}-${idx}`}>
                                                {submodule.SubModulesName}
                                            </label>
                                        </div>
                                    ))
                                ) : (
                                    <p className="text-muted">No Submodules</p>
                                )}
                            </div>
                            <hr />
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default MenubarTable;

